import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'put'

export default class OspreyOffersUpdate extends BaseAction {
    constructor(dataKey) {
        const id = 'ada9a3db-1436-4669-9f92-6e3d1c1898af'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    update(offer) {
        if (!offer) {
            throw new Error('Missing offer object')
        }

        this.path = `/${resource}/${offer.id.value}`

        this.params = {
            offer
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-update.js